import React, { useState } from "react";
import "./BlogCard.scss";
import ReactMarkdown from "react-markdown";

export default function BlogCard({ blog, isDark }) {
  const [isExpanded, setIsExpanded] = useState(false);

  function openUrlInNewTab(url, name) {
    if (!url) {
      console.log(`URL for ${name} not passed`);
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  const resolveImagePath = (src) => {
    const filename = src.split("/").pop();
    try {
      return require(`../../assets/images/${filename}`);
    } catch (e) {
      console.error(`Image not found: ${filename}`, e);
      return null;
    }
  };

  const handleClick = (e) => {
    e.stopPropagation();
    if (!blog.url.startsWith("http")) {
      setIsExpanded(!isExpanded);
    } else {
      openUrlInNewTab(blog.url, blog.title);
    }
  };

  return (
    <div onClick={handleClick}>
      <div className={isDark ? "blog-container dark-mode" : "blog-container"}>
        <div
          className={
            isDark ? "dark-mode blog-card blog-card-shadow" : "blog-card"
          }
        >
          <h3 className={isDark ? "small-dark blog-title" : "blog-title"}>
            {blog.title}
          </h3>
          {!isExpanded && (
            <p className={isDark ? "small-dark small" : "small"}>
              {blog.description || "Click to expand"}
            </p>
          )}
          {isExpanded && blog.content && (
            <ReactMarkdown
              className={isDark ? "small-dark markdown-content" : "markdown-content"}
              components={{
                img: ({ src, alt }) => {
                  const imagePath = resolveImagePath(src);
                  return imagePath ? (
                    <img src={imagePath} alt={alt} style={{ maxWidth: "100%" }} />
                  ) : (
                    <span>Image not found: {alt}</span>
                  );
                },
              }}
            >
              {blog.content}
            </ReactMarkdown>
          )}
          {blog.url.startsWith("http") && (
            <div className="go-corner" onClick={() => openUrlInNewTab(blog.url, blog.title)}>
              <div className="go-arrow">→</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}